"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9090],{

/***/ 30530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ImageList_ImageList; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/@mui/base/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(93427);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(93680);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(78884);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ImageList/imageListClasses.js


function getImageListUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiImageList', slot);
}
const imageListClasses = (0,generateUtilityClasses/* default */.Z)('MuiImageList', ['root', 'masonry', 'quilted', 'standard', 'woven']);
/* harmony default export */ var ImageList_imageListClasses = ((/* unused pure expression or super */ null && (imageListClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ImageList/ImageListContext.js
var ImageListContext = __webpack_require__(29057);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ImageList/ImageList.js


const _excluded = ["children", "className", "cols", "component", "rowHeight", "gap", "style", "variant"];











const useUtilityClasses = ownerState => {
  const {
    classes,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant]
  };
  return (0,composeClasses/* default */.Z)(slots, getImageListUtilityClass, classes);
};

const ImageListRoot = (0,styled/* default */.ZP)('ul', {
  name: 'MuiImageList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant]];
  }
})(({
  ownerState
}) => {
  return (0,esm_extends/* default */.Z)({
    display: 'grid',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
  }, ownerState.variant === 'masonry' && {
    display: 'block'
  });
});
const ImageList = /*#__PURE__*/react.forwardRef(function ImageList(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiImageList'
  });

  const {
    children,
    className,
    cols = 2,
    component = 'ul',
    rowHeight = 'auto',
    gap = 4,
    style: styleProp,
    variant = 'standard'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const contextValue = react.useMemo(() => ({
    rowHeight,
    gap,
    variant
  }), [rowHeight, gap, variant]);
  react.useEffect(() => {
    if (false) {}
  }, []);
  const style = variant === 'masonry' ? (0,esm_extends/* default */.Z)({
    columnCount: cols,
    columnGap: gap
  }, styleProp) : (0,esm_extends/* default */.Z)({
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gap
  }, styleProp);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    gap,
    rowHeight,
    variant
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageListRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, classes[variant], className),
    ref: ref,
    style: style,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageListContext/* default.Provider */.Z.Provider, {
      value: contextValue,
      children: children
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ImageList_ImageList = (ImageList);

/***/ }),

/***/ 29057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

const ImageListContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ImageListContext);

/***/ }),

/***/ 80412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ImageListItem_ImageListItem; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/@mui/base/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(93427);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(93680);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(48570);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ImageList/ImageListContext.js
var ImageListContext = __webpack_require__(29057);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(78884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/isMuiElement.js + 1 modules
var isMuiElement = __webpack_require__(37412);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(45154);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(22104);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ImageListItem/imageListItemClasses.js


function getImageListItemUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiImageListItem', slot);
}
const imageListItemClasses = (0,generateUtilityClasses/* default */.Z)('MuiImageListItem', ['root', 'img', 'standard', 'woven', 'masonry', 'quilted']);
/* harmony default export */ var ImageListItem_imageListItemClasses = (imageListItemClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/ImageListItem/ImageListItem.js


const _excluded = ["children", "className", "cols", "component", "rows", "style"];













const useUtilityClasses = ownerState => {
  const {
    classes,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant],
    img: ['img']
  };
  return (0,composeClasses/* default */.Z)(slots, getImageListItemUtilityClass, classes);
};

const ImageListItemRoot = (0,styled/* default */.ZP)('li', {
  name: 'MuiImageListItem',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${ImageListItem_imageListItemClasses.img}`]: styles.img
    }, styles.root, styles[ownerState.variant]];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'block',
  position: 'relative'
}, ownerState.variant === 'standard' && {
  // For titlebar under list item
  display: 'flex',
  flexDirection: 'column'
}, ownerState.variant === 'woven' && {
  height: '100%',
  alignSelf: 'center',
  '&:nth-of-type(even)': {
    height: '70%'
  }
}, {
  [`& .${ImageListItem_imageListItemClasses.img}`]: (0,esm_extends/* default */.Z)({
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    display: 'block'
  }, ownerState.variant === 'standard' && {
    height: 'auto',
    flexGrow: 1
  })
}));
const ImageListItem = /*#__PURE__*/react.forwardRef(function ImageListItem(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiImageListItem'
  }); // TODO: - Use jsdoc @default?: "cols rows default values are for docs only"

  const {
    children,
    className,
    cols = 1,
    component = 'li',
    rows = 1,
    style
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const {
    rowHeight = 'auto',
    gap,
    variant
  } = react.useContext(ImageListContext/* default */.Z);
  let height = 'auto';

  if (variant === 'woven') {
    height = undefined;
  } else if (rowHeight !== 'auto') {
    height = rowHeight * rows + gap * (rows - 1);
  }

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    cols,
    component,
    gap,
    rowHeight,
    rows,
    variant
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageListItemRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, classes[variant], className),
    ref: ref,
    style: (0,esm_extends/* default */.Z)({
      height,
      gridColumnEnd: variant !== 'masonry' ? `span ${cols}` : undefined,
      gridRowEnd: variant !== 'masonry' ? `span ${rows}` : undefined,
      marginBottom: variant === 'masonry' ? gap : undefined
    }, style),
    ownerState: ownerState
  }, other, {
    children: react.Children.map(children, child => {
      if (! /*#__PURE__*/react.isValidElement(child)) {
        return null;
      }

      if (false) {}

      if (child.type === 'img' || (0,isMuiElement/* default */.Z)(child, ['Image'])) {
        return /*#__PURE__*/react.cloneElement(child, {
          className: (0,clsx_m/* default */.Z)(classes.img, child.props.className)
        });
      }

      return child;
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ImageListItem_ImageListItem = (ImageListItem);

/***/ }),

/***/ 53694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HomeLoggedOut": function() { return /* binding */ HomeLoggedOut; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63348);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87044);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49830);
/* harmony import */ var _components_Skeletons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57758);
/* harmony import */ var _categoriesData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23576);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21566);
/* harmony import */ var _components_AssistantButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78459);
/* harmony import */ var _hooks_useFacebookPixel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14931);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var _components_homeNavBar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88617);
/* harmony import */ var _landing_HeroSection_categoriesCard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9762);
/* harmony import */ var src_validators_Events_Product__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63475);













function HomeLoggedOut() {
    var loading = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .a)().loading;
    var categorySlugs = [
        "belleza",
        "accesorios-y-dispositivos",
        "cuidado-personal",
        "vitaminas-y-suplementos", 
    ];
    var trackFBEvent = (0,_hooks_useFacebookPixel__WEBPACK_IMPORTED_MODULE_8__/* .useFacebokPixelEvent */ .o)().trackFBEvent;
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function trackLandingView() {
        trackFBEvent("track", "ViewContent", {});
    }, [
        trackFBEvent
    ]);
    if (loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_homeNavBar__WEBPACK_IMPORTED_MODULE_10__/* .HomeNavBar */ .y, {
                isVisible: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .HomeRootDiv */ .YO, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .SidePadding */ .t4, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .HelloLoggedOut */ .si, {})
                    }),
                    _categoriesData__WEBPACK_IMPORTED_MODULE_5__/* ["default"].length */ .Z.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_landing_HeroSection_categoriesCard__WEBPACK_IMPORTED_MODULE_11__/* .CategoriesCard */ .g, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Skeletons__WEBPACK_IMPORTED_MODULE_4__/* .CategoriesSliderSkeleton */ .k, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .SidePadding */ .t4, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .CarouselsContainer */ .ZD, {
                            children: categorySlugs.map(function(slug) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .CategoryProducts */ .DP, {
                                    slug: slug,
                                    productLocation: src_validators_Events_Product__WEBPACK_IMPORTED_MODULE_12__/* .ProductInteractionLocation.HomeLoggedOutCategories */ .qv.HomeLoggedOutCategories,
                                    categoryLocation: "home logged out"
                                }, slug);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_footer__WEBPACK_IMPORTED_MODULE_1__/* .Footer */ .$, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AssistantButton__WEBPACK_IMPORTED_MODULE_7__/* .AssistantButton */ .q, {})
        ]
    });
}


/***/ })

}]);